import React, { useEffect, useState } from 'react'
import styles from './styles'
import { withStyles, Typography } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import MailPreparation from './mail-preparation'
import MailSent from './mail-sent'
import MailCName from './mail-cname'
import { sendMailToLearnerAction } from 'src/reducers/teams/action'
import { track } from '@amplitude/analytics-browser'
import { PatchContent, PatchData } from 'src/model/patch'
import { patchCollectionSettingsAction } from 'src/reducers/collection/action'
import CountrySelect from 'src/components/language-selection'
import { defaultEmailSettings } from 'src/model/languages'
import { languages } from 'src/model/languages'
import { CoreButton } from 'src/components/core'
import { messageBoxHideAction } from 'src/reducers/message-box/action'

const DEFAULT_SHARE_DOMAIN = process.env.REACT_APP_VIEW_URL?.replace(/^https?:\/\//, '').replace(/\/$/, '') || 'share.minicoursegenerator.com'

const MagicViewContent = props => {
  const { handleBack, closeDrawer } = props
  const entity = useSelector(state => state.collection.collection)
  const collectionSettings = useSelector(
    state => state.collection.collectionSettings,
  )
  const [selectedDomain, setSelectedDomain] = useState(
    DEFAULT_SHARE_DOMAIN,
  )
  const dispatch = useDispatch()

  const [mailSent, setMailSent] = React.useState(false)
  const sendMail = () => {
    dispatch(
      sendMailToLearnerAction(
        entity.id,
        sendLinkToNewMembersOnly,
        selectedDomain,
        response => setMailSent(true),
      ),
    )
    track('magiclink_email_sent')
  }
  const [
    sendLinkToNewMembersOnly,
    setSendLinkToNewMembersOnly,
  ] = React.useState(collectionSettings.sendLinkToNewMembersOnly)

  const handleSendLinkToNewMembersOnly = value => {
    setSendLinkToNewMembersOnly(value)
    const patchSource = new PatchData(null, entity.id)
    patchSource.addContent(
      new PatchContent(
        value,
        'sendLinkToNewMembersOnly',
        PatchData.OPERATION_REPLACE,
      ),
    )

    dispatch(patchCollectionSettingsAction(patchSource, response => {}))
  }
  const [emailText, setEmailText] = React.useState(
    collectionSettings.inviteEmailBody,
  )
  const [emailSettings, setEmailSettings] = useState()
  const languageOptions = languages
  const [languageSelection, setLanguageSelection] = React.useState(
    languageOptions.find(
      collectionSettings.countryCode
        ? x => x.countryCode === collectionSettings.countryCode
        : x => x.countryCode === 'en',
    ),
  )

  const [emailTitle, setEmailTitle] = useState(
    collectionSettings.inviteEmailSubject != null
      ? collectionSettings.inviteEmailSubject
      : emailSettings &&
          emailSettings[languageSelection.countryCode].find(
            x => x.key == 'invite_member_subject',
          ).text,
  )

  const handleChangeLanguage = e => {
    if (e === null) return
    setLanguageSelection(e)
    const patchSource = new PatchData(null, entity.id)
    patchSource.addContent(
      new PatchContent(
        e.countryCode,
        'countryCode',
        PatchData.OPERATION_REPLACE,
      ),
    )

    dispatch(patchCollectionSettingsAction(patchSource, response => {}))

    const newPatchSource = new PatchData(null, entity.id)
    newPatchSource.addContent(
      new PatchContent(
        emailSettings[e.countryCode].find(
          x => x.key == 'invite_member_inner',
        ).text,
        'inviteEmailBody',
        PatchData.OPERATION_REPLACE,
      ),
    )
    newPatchSource.addContent(
      new PatchContent(
        emailSettings[e.countryCode].find(
          x => x.key == 'invite_member_subject',
        ).text,
        'inviteEmailSubject',
        PatchData.OPERATION_REPLACE,
      ),
    )

    setEmailText(
      emailSettings[e.countryCode].find(x => x.key == 'invite_member_inner')
        .text,
    )
    setEmailTitle(
      emailSettings[e.countryCode].find(x => x.key == 'invite_member_subject')
        .text,
    )
    dispatch(patchCollectionSettingsAction(newPatchSource, response => {}))
  }

  useEffect(() => {
    if (emailSettings) return
    const grouped = defaultEmailSettings.reduce((acc, item) => {
      acc[item.countryCode] = acc[item.countryCode] || []
      acc[item.countryCode].push(item)
      return acc
    }, {})
    setEmailSettings(grouped)
  }, [languageSelection, emailSettings])

  useEffect(() => {
    emailSettings &&
      emailTitle == null &&
      setEmailTitle(
        emailSettings[languageSelection.countryCode].find(
          x => x.key == 'invite_member_subject',
        ).text,
      )
  }, [emailSettings])

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          gap: 16,
          maxHeight: '70vh',
          overflow: 'auto',
          paddingRight: '8px',
        }}
      >
        {mailSent ? (
          <>
            <MailSent closeDrawer={closeDrawer} handleBack={handleBack} />
          </>
        ) : (
          <>
            <Typography
              fontSize={'15px'}
              fontWeight={600}
              style={{ color: '#002E47' }}
            >
              Email Settings
            </Typography>

            <div
              style={{
                gap: 16,
                borderRadius: 8,
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <CountrySelect
                languageSelection={languageSelection}
                setLanguageSelection={handleChangeLanguage}
              />
              <MailPreparation
                handleSendLinkToNewMembersOnly={handleSendLinkToNewMembersOnly}
                sendLinkToNewMembersOnly={sendLinkToNewMembersOnly}
                entity={entity}
                collectionSettings={collectionSettings}
                dispatch={dispatch}
                emailText={emailText}
                setEmailText={setEmailText}
                emailTitle={emailTitle}
                setEmailTitle={setEmailTitle}
              />
            </div>
            <Typography
              fontSize={'15px'}
              fontWeight={600}
              style={{ color: '#002E47' }}
            >
              Custom Domain Settings
            </Typography>
            <div
              style={{
                padding: 16,
                gap: 16,
                borderRadius: 8,
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <MailCName
                entity={entity}
                dispatch={dispatch}
                selectedDomain={selectedDomain}
                setSelectedDomain={setSelectedDomain}
              />
            </div>
          </>
        )}
      </div>
      {!mailSent && (
        <div
          style={{
            display: 'flex',
            gap: 16,
            justifyContent: 'flex-end',
          }}
        >
          <CoreButton
            onClick={() => {
              dispatch(messageBoxHideAction())
            }}
            variant="text"
            color="secondary"
          >
            Cancel
          </CoreButton>

          <CoreButton onClick={sendMail} variant="contained" color="primary">
            Send email
          </CoreButton>
        </div>
      )}
    </div>
  )
}

export default withStyles(styles)(MagicViewContent)
